document.addEventListener('DOMContentLoaded', function () {
  var productCards = document.querySelectorAll('.product-card-v2');

  productCards.forEach(function (productCard) {
    var variantOptions = productCard.querySelectorAll('.variant-option');
    var isLinkedProduct = variantOptions.length > 0;

    if (variantOptions.length > 0) {
      var productPrice = productCard.querySelector('.product-price');
      var comparePriceWrapper = productCard.querySelector('.product-compare-wrapper');
      var comparePrice = productCard.querySelector('.product-compare-price');
      var productUnitPrice = productCard.querySelector('.unit-price');
      var productTitleLink = productCard.querySelector('.cart-product-link');
      var productCardLink = productCard.querySelector('.product-card--link');
      var productImageLink = productCard.querySelector('.product-featured-image-link');
      var productDesc = productCard.querySelector('.short-desc');
      var ratingSnippet = productCard.querySelector('.ruk_rating_snippet');
      var primaryImageNode = productCard.querySelector('.product-primary-image');
      var primaryImg = primaryImageNode
        ? (primaryImageNode.tagName.toLowerCase() === 'img'
            ? primaryImageNode
            : primaryImageNode.querySelector('img'))
        : null;
      
      // Store original values
      var originalPrice = productPrice ? productPrice.getAttribute('data-original-price') : null;
      var originalUnitPrice = productUnitPrice ? productUnitPrice.getAttribute('data-original-unit-price') : null;
      var originalUrl = productCard.getAttribute('data-product-url');
      var originalLink = productCardLink ? productCardLink.getAttribute('data-original-link') : null;
      var originalDesc = productDesc ? productDesc.getAttribute('data-original-desc') : null;
      var originalSku = ratingSnippet ? ratingSnippet.getAttribute('data-original-sku') : null;

      variantOptions.forEach(function (variantOption) {
        variantOption.addEventListener('click', function () {
          var isLinked = variantOption.classList.contains('linked-product-option');
          var newPrice = variantOption.getAttribute('data-price');
          var newUnitPrice = variantOption.getAttribute('data-unit-price');
          var newComparePrice = variantOption.getAttribute('data-compare-price');
          var hasComparePrice = variantOption.getAttribute('data-has-compare') === 'true';
          var newSrc = variantOption.getAttribute('data-image-src');
          var newSrcset = variantOption.getAttribute('data-image-srcset');
          var newAlt = variantOption.getAttribute('data-image-alt');
          
          // Update price
          if (newPrice && productPrice) {
            productPrice.textContent = newPrice;
          }
          
          // Update compare-at price
          if (comparePriceWrapper && comparePrice) {
            if (hasComparePrice && newComparePrice) {
              comparePrice.textContent = newComparePrice;
              comparePriceWrapper.classList.remove('hidden');
            } else {
              comparePriceWrapper.classList.add('hidden');
            }
          }

          // Update unit price
          if (productUnitPrice) {
            if (newUnitPrice) {
              productUnitPrice.textContent = newUnitPrice;
              productUnitPrice.classList.remove('hidden');
            } else {
              productUnitPrice.classList.add('hidden');
            }
          }

          // Update image
          if (newSrc && primaryImg) {
            primaryImg.setAttribute('src', newSrc);
            primaryImg.setAttribute('data-src', newSrc);
            
            if (newSrcset) {
              primaryImg.setAttribute('srcset', newSrcset);
              primaryImg.setAttribute('data-srcset', newSrcset);
            }
            
            if (newAlt) primaryImg.setAttribute('alt', newAlt);

            if (primaryImageNode && primaryImageNode.tagName.toLowerCase() === 'picture') {
              primaryImageNode.querySelectorAll('source').forEach(function (s) {
                if (newSrcset) {
                  s.setAttribute('srcset', newSrcset);
                  s.setAttribute('data-srcset', newSrcset);
                }
              });
            }
          }
          
          // Update links if it's a linked product
          if (isLinked) {
            var newUrl = variantOption.getAttribute('data-product-url');
            var newSku = variantOption.getAttribute('data-product-sku');
            var newDesc = variantOption.getAttribute('data-product-desc');
            
            if (newUrl) {
              if (productTitleLink) {
                productTitleLink.setAttribute('href', newUrl);
              }
              if (productCardLink) {
                productCardLink.setAttribute('href', newUrl);
              }
              if (productImageLink) {
                productImageLink.setAttribute('href', newUrl);
              }
            }
            
            if (newDesc !== null && productDesc) {
              productDesc.textContent = newDesc || '';
            }
            
            if (newSku && ratingSnippet) {
              var linkedRating = productCard.querySelector('.ruk_rating_snippet_linked');
              if (linkedRating) {
                ratingSnippet.setAttribute('data-sku', newSku);
                linkedRating.setAttribute('data-sku', newSku);
              }
            }
          } else {
            // Reset to original values for regular variants
            if (originalUrl && productTitleLink) {
              productTitleLink.setAttribute('href', originalUrl);
            }
            
            if (originalLink && productCardLink) {
              productCardLink.setAttribute('href', originalLink);
            }
            
            if (originalUrl && productImageLink) {
              productImageLink.setAttribute('href', originalUrl);
            }
            
            if (originalDesc !== null && productDesc) {
              productDesc.textContent = originalDesc || '';
            }
            
            if (originalSku && ratingSnippet) {
              ratingSnippet.setAttribute('data-sku', originalSku);
            }
          }
        });
      });
    }
  });
});

